import { render } from "./Board-of-Regents.vue?vue&type=template&id=6754cafa&scoped=true"
import script from "./Board-of-Regents.vue?vue&type=script&lang=js"
export * from "./Board-of-Regents.vue?vue&type=script&lang=js"

import "./Board-of-Regents.vue?vue&type=style&index=0&id=6754cafa&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3816345015/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6754cafa"]])

export default __exports__